import { Directive, DirectiveBinding } from 'vue';
import { hasPermission } from '../utils/permission';

const permissionDirective: Directive = {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    const { value } = binding;
    
    if (!value) {
      throw new Error('v-permission directive value is missing');
    }

    if (!hasPermission(value)) {
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      } else {
        el.style.display = 'none';
      }
    }
  },
  updated(el: HTMLElement, binding: DirectiveBinding) {
    const { value } = binding;
    if (!value) {
        return;
    }
    if (!hasPermission(value)) {
        if (el.parentNode) {
            el.parentNode.removeChild(el);
        } else {
            el.style.display = 'none';
        }
    }
  }
};

export default permissionDirective;
